import { useRef } from "react";
import { toast } from "sonner";

// Once the user has entered anything in a dialog, clicking outside it or pressing
// Escape no longer dismisses it (which would silently lose the entered data).
// Explicit Cancel / X / save buttons still close it. Spread `guardProps` onto
// <DialogContent>; `dirty` is exposed for dialogs needing a close confirmation.
//
// `watched` — array of state values that represent the user's entries.
// `ready`   — pass false while the form is still loading so the initial
//             snapshot is taken from the loaded values, not the empty state.
export default function useUnsavedGuard(watched, ready = true) {
  const initial = useRef(null);
  const snapshot = JSON.stringify(watched);
  if (ready && initial.current === null) initial.current = snapshot;
  const dirty = initial.current !== null && snapshot !== initial.current;

  const block = (e) => {
    if (!dirty) return;
    e.preventDefault();
    toast.message("Your entries are kept", {
      id: "unsaved-guard",
      description: "This window stays open so nothing is lost. Use Cancel to discard or the save button to keep it.",
    });
  };

  return { dirty, guardProps: { onInteractOutside: block, onEscapeKeyDown: block } };
}
